// extracted by mini-css-extract-plugin
module.exports = {"container":"PlayerMoveAlert_container__2WraG","title":"PlayerMoveAlert_title__1Z4fd","hidden":"PlayerMoveAlert_hidden__3YPUn","dismiss":"PlayerMoveAlert_dismiss__3nlW7"};